<template>
  <div class="container">
    <div class="calendar">
      <div class="flexCenter header">
        <div class="left"></div>
        <div class="flexCenter middle">
          <img :src="srcImg+'left.png'" @click="preMonth(year,month)" alt>
          <div class="month font-pfb font30">{{year}} 年 {{month+1}} 月</div>
          <img :src="srcImg+'right.png'" @click="nextMonth(year,month)" alt>
        </div>
        <div
          v-bind:class="{hidden: hidden}"
          class="right font24 cfe4 font-pfb"
          @click="goToday(today)"
        >回到今天</div>
      </div>
      <ul class="weekdays font-pfb font24">
        <li>日</li>
        <li>一</li>
        <li>二</li>
        <li>三</li>
        <li>四</li>
        <li>五</li>
        <li>六</li>
      </ul>
      <ul class="days" @click="bindClickDay">
        <li
          v-for="day in days"
          :key="day.id"
          v-bind:date="(day.date)!=''?formatDate(year,month+1,day.date):''"
        >
          <div
            class="date-background font-pfb font28"
            :class="day.statu!=1 && day.statu!=4 && day.statu!=5 && day.statu!=6?statuClass[day.statu]:''"
          >
            <div class="selected" v-if="formatDate(year,month+1,day.date) == currentDay"></div>
            <div
              class="date"
              :class="checkClass(day)"
              v-if="formatDate(year,month+1,day.date) == currentDay"
            >{{day.date}}</div>
            <div class="date" :class="checkClass(day)" v-else>{{day.date}}</div>
            <div
              class="label font23 font-pfb"
              :class="day.statu ==1 || day.statu==4 || day.statu==5 || day.statu==6?'c8194':''"
              v-if="formatDate(year,month+1,day.date) == today"
            >今日</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "calendar",
  components: {},
  data() {
    return {
      year: "", //年份
      month: "", //月份
      weekday: 1, //星期几,0为周日
      days: [], //每月的天数
      currentDay: "", //点选的日期
      today: "",
      firstDate: "", //每月第一天日期
      lastDate: "", //每月最后一天日期
      dayOfMonth: [], //每月天数
      future: false, //是否显示选项按钮
      type: "begin",
      isChecked: false,
      disabled: false,
      status: [], //当月每天对应的状态
      hidden: true, //是否隐藏回到今天
      statuClass: [
        "statu-cal",
        "statu-mense",
        "statu-safe",
        "statu-ovulation",
        "statu-mense-single",
        "statu-mense-start",
        "statu-mense-end",
        "statu-ov"
      ], //样式集合
      saturdays: [],
      sundays: [],
      history: [] //当月的经期设置数组
    };
  },

  watch: {},

  computed: {},
  methods: {
    /**
     * 初始化日历(不含状态)
     * @param  {Data}  param [需要进行渲染的日期对象]
     * @return {[type]} [description]
     */
    initCalendar: function(param) {
      this.days = [];
      let date = new Date();

      if (param) {
        date = param;
      }
      date.setDate(1); //设置当月日期为1
      this.getSatAndSun(date.getFullYear(), date.getMonth() + 1);

      this.weekday = date.getDay();
      this.year = date.getFullYear();
      this.month = date.getMonth();

      let temp = new Date(this.year, this.month + 1, 0);

      this.lastDate = this.formatDate(
        this.year,
        this.month + 1,
        temp.getDate()
      );
      this.firstDate = this.formatDate(this.year, this.month + 1, 1);

      this.dayOfMonth = [
        31,
        28 + this.isLeapYear(this.year),
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ]; //每个月的天数
      this.fillDays([]);
    },
    /**
     * 判断是否问闰年
     * @param  {[type]}  year [需要判断的年份]
     * @return {Boolean}      [description]
     */
    isLeapYear: function(year) {
      if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 选择日期回调
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    bindClickDay: function(e) {
      var day = "";
      if (e.target.nodeName != "UL") {
        day = this.closet(e);
      }
      if (day != "") {
        this.currentDay = day;
        if (
          parseInt(this.today.split("-").join("")) <
          parseInt(this.currentDay.split("-").join(""))
        ) {
          this.future = true;
        } else {
          this.future = false;
          this.changeCheckBox(this.currentDay);
        }
      }

      // this.fillDays(this.filljqData(["2018-05-18"], [ "2018-05-19"], this.status));
    },
    /**
     * 选择按钮回调,每次点选成功都会重新刷新每日状态
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    bindChange: function(e) {
      this.disabled = true;
      let me = this;
      let url = "";
      let token = sessionStorage.getItem("token");
      this.isChecked = e.target.checked;
      if (this.type == "begin") {
        url = this.config.recordStart;
      }
      if (this.type == "end") {
        url = this.config.recordEnd;
      }

      this.axios({
        method: "post",
        url: url,
        headers: {
          Authorization: "Bearer " + token
        },
        data: {
          startTime: me.currentDay,
          ischecked: me.isChecked
        }
      }).then(result => {
        if (result.data.code == 200) {
          me.getStatuData(me.currentDay, true, false);
          // setTimeout(()=>{

          me.disabled = false;
          // },2000)
        } else {
        }
      });
    },

    /**
     * 需要通过startDates和endDates的判断
     * @param  {[type]} curDate [description]
     * @return {[type]}         [description]
     */
    changeCheckBox: function(curDate) {
      this.getStatuData(curDate, false, true);
    },

    preMonth: function(year, month) {
      if (month == 0) {
        this.year = year - 1;
        this.month = 11;
      } else {
        this.month = month - 1;
      }
      this.isTodayMonth(this.year, this.month);
      let tempdate = new Date(this.formatDate(this.year, this.month + 1, 1));
      this.initCalendar(tempdate);
      this.getStatuData("", true, false);
    },

    nextMonth: function(year, month) {
      if (month == 11) {
        this.year = year + 1;
        this.month = 0;
      } else {
        this.month = month + 1;
      }
      this.isTodayMonth(this.year, this.month);
      let tempdate = new Date(this.formatDate(this.year, this.month + 1, 1));
      this.initCalendar(tempdate);
      this.getStatuData("", true, false);
    },
    //回到今天
    goToday: function(today) {
      // this.currentDay = today;
      this.hidden = true;
      this.initCalendar(new Date(today));
      this.getStatuData("", true, false);
    },

    /**
     * 检查是否是今天的月份，如果是则显示“回到今天”否则不显示
     * @param  {String}  year  [需要验证的年份]
     * @param  {String}  month [需要验证的月份]
     * @return {Boolean}       [当前月为true]
     */
    isTodayMonth: function(year, month) {
      let todayArr = this.today.split("-");
      if (year == todayArr[0] && month + 1 == todayArr[1][1]) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },

    closet: function(e) {
      var temp = e.target;
      while (1) {
        if (temp.nodeName == "LI") {
          return temp.getAttribute("date");
        } else {
          temp = temp.parentNode;
        }
      }
    },

    /**
     * 获取当月的所有周日和周六日期
     * @param  {[type]} year  [description]
     * @param  {[type]} month [description]
     */
    getSatAndSun: function(year, month) {
      let tempTime = new Date(year, month, 0);
      let time = new Date();
      let saturday = [];
      let sunday = [];

      for (var i = 1; i <= tempTime.getDate(); i++) {
        time.setFullYear(year, month - 1, i);
        var day = time.getDay();
        if (day == 6) {
          saturday.push(i);
        } else if (day == 0) {
          sunday.push(i);
        }
      }
      this.saturdays = saturday;
      this.sundays = sunday;
    },

    /**
     * 分配不同状态的class
     * @param  {[type]} day [description]
     * @return {[type]}     [description]
     */
    checkClass: function(day) {
      let me = this;
      if (this.saturdays.indexOf(day.date) != -1) {
        if (day.statu == 1 || day.statu == 6) {
          return "statu-mense-end";
        } else if (day.statu == 5 || day.statu == 4) {
          return "statu-mense-single";
        }
      }

      if (this.sundays.indexOf(day.date) != -1) {
        if (day.statu == 1 || day.statu == 5) {
          return "statu-mense-start";
        } else if (day.statu == 6 || day.statu == 4) {
          return "statu-mense-single";
        }
      }

      if (
        day.statu == 1 ||
        day.statu == 4 ||
        day.statu == 5 ||
        day.statu == 6
      ) {
        var className = me.statuClass[day.statu];
        var obj = {};
        obj[className] = true;
        return obj;
      }
    },

    /**
     * 获取每日状态,并且返回相应状态数组
     * @return {[type]} [description]
     */
    getStatuData: function(day, changeCalendar, changeCheck) {
      let me = this;
      let token = sessionStorage.getItem("token");
      this.axios({
        method: "post",
        url: me.config.calendar,
        headers: {
          Authorization: "Bearer " + token
        },
        data: {
          thisDate: this.formatDate(this.year, this.month + 1, 1),
          selectDate: day
        }
      }).then(result => {
        let start = [];
        let end = [];

        let history = result.data.historys;

        history.forEach((val, index) => {
          let tempStartDate = new Date(val.menstrua_start);
          let tempEndDate = new Date(val.menstrua_end);
          let tempToday = new Date(me.today);

          if (tempStartDate.getMonth() == me.month) {
            start.push(val.menstrua_start);
          } else {
            if (tempToday.getMonth() >= me.month) {
              //判断是否为当月之前(包括当月)
              start.push(me.firstDate);
            }
          }

          let men_end = val.menstrua_end || me.today;

          if (tempEndDate.getMonth() <= tempToday.getMonth()) {
            if (tempEndDate.getMonth() == me.month) {
              if (
                parseInt(this.today.split("-").join("")) <=
                  parseInt(men_end.split("-").join("")) &&
                tempToday.getMonth() == me.month
              ) {
                end.push(me.today);
              } else {
                end.push(men_end);
              }
            } else {
              end.push(me.lastDate);
            }
          } else {
            if (
              parseInt(this.today.split("-").join("")) <=
                parseInt(men_end.split("-").join("")) &&
              tempToday.getMonth() == me.month
            ) {
              end.push(me.today);
            }
          }
        });

        if (changeCheck) {
          me.isChecked = result.data.menstrua.status;
          me.type = result.data.menstrua.con == "经期开始" ? "begin" : "end";
        }

        if (changeCalendar) {
          me.status = result.data.timelast;
          me.fillDays(me.filljqData(start.sort(), end.sort(), me.status));
        }
      });
    },

    /**
     * 通过状态填装相应的样式
     * @param  {Array} start  经期开始日期数组
     * @param  {Array} end    经期结束日期数组
     * @param  {Array} status 后端返回的每日状态数组
     * @return {Array}        整理后的样式数组
     */
    filljqData: function(start, end, status) {
      if (!start || !end) return;
      let tempStatus = [];
      //如果只有经期开始 没有经期结束日期则经期时间自动延长至今天
      if (end[end.length - 1] == null && start[start.length - 1] != null) {
        end[end.length - 1] = this.today;
      }
      if (end[0] == null && start[0] != null) {
        end[0] = this.today;
      }

      let tempStart = false;
      status.forEach((val, index) => {
        if (start[0] == val.date && end[0] == val.date) {
          tempStatus.push("4");
          start.shift();
          end.shift();
          tempStart = false;
          return;
        }

        if (start[0] == val.date) {
          tempStatus.push("5");
          start.shift();
          tempStart = true;
          return;
        }

        if (end[0] == val.date) {
          tempStatus.push("6");
          end.shift();
          tempStart = false;
          return;
        }

        if (tempStart) {
          tempStatus.push("1");
          return;
        }

        if (val.dateType == "red") {
          tempStatus.push("0");
        }
        if (val.dateType == "safe") {
          tempStatus.push("2");
        }
        if (val.dateType == "pl") {
          tempStatus.push("3");
        }

        if (val.dateType == "plr") {
          if (
            index != 0 &&
            index != status.length - 1 &&
            status[index - 1].dateType == "red" &&
            status[index + 1].dateType == "red"
          ) {
            //如果前后都是红色则显示为红色
            tempStatus.push("0");
          } else {
            tempStatus.push("7");
          }
        }
      });
      return tempStatus;
    },

    /**
     * 填装状态
     * @return {[type]} [description]
     */
    fillDays: function(status) {
      // let tempStatus = this.parseStatus(status);
      let tempStatus = status;
      let tempDays = [];
      //装配目标月份日期
      for (let i = 1; i <= this.dayOfMonth[this.month]; i++) {
        let tempObj = {
          id: i,
          date: i,
          statu: tempStatus[i - 1]
        };
        tempDays.push(tempObj);
      }
      this.days = tempDays;
      //装配目标月份空白天数
      for (let i = 1; i <= this.weekday; i++) {
        this.days.unshift({
          id: "e" + i,
          date: "",
          statu: 2
        });
      }
    }
  },

  created: function() {
    let date = new Date();
    this.today = this.formatDate(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate()
    );
    this.currentDay = this.today;
    this.initCalendar();

    if (sessionStorage.getItem("token") != null) {
      this.getStatuData(this.today, true, true);
    }
  },

  activated: function() {}
};
</script>
<style lang='less' scoped>
// @import url("./calendar.less");
// @import url("./animate.css");
</style>



// WEBPACK FOOTER //
// src/globalComponent/calendar/calendar.vue